import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "../style/binCard.css";
import api from "../services/api";

import bin2 from "../images/2m3.png";
import bin3 from "../images/3m3.png";
import bin4 from "../images/4m3.png";
import bin6 from "../images/6m3.png";
import bin8 from "../images/8m3.png";
import bin10 from "../images/10m3.png";

const sizeImageMap = {
  "2m3": bin2,
  "3m3": bin3,
  "4m3": bin4,
  "6m3": bin6,
  "8m3": bin8,
  "10m3": bin10,
};

const BinCard = () => {
  const [binSizes, setBinSizes] = useState([]);

  useEffect(() => {
    api.get("/bins").then(res => setBinSizes(res.data));
  }, []);

  return (
    <section className="skip-bins-section">
      <div className="skip-bins-header">
        <span className="our-bins-label">OUR BINS</span>
        <h2>Skip Bin Sizes</h2>
      </div>

      <div className="skip-bins-grid">
        {binSizes.map((bin, index) => {
          const sizeKey = bin.size?.toLowerCase().replace(/\s/g, "").replace("³", "3").replace("m", "m");
          const image = sizeImageMap[sizeKey] || bin2;
          return (
            <div className="bin-cardd" key={index}>
              <div className="bin-image-wrap">
                <img src={image} alt={`${bin.size} Skip Bin`} />
              </div>
              <div className="bin-info">
                <h3>{bin.size}</h3>
                <NavLink to={`/booking?bin=${bin.bin_id}`} className="bin-book-btn">
                  BOOK NOW
                </NavLink>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default BinCard;